import { useState } from "react";
import { Alert, Dialog, DialogContent, DialogTitle } from "@mui/material";
import type { PaidPlanId, PlanId } from "@ebook/contracts";
import { api } from "../lib/api-client";
import { useTranslate } from "../i18n";
import { useAuthStore } from "../stores/auth-store";
import { PaymentSlipDialog } from "./PaymentSlipDialog";
import { PlanGrid } from "./PlanGrid";

type PlanUpgradeDialogProps = {
  open: boolean;
  onClose: () => void;
};

export function PlanUpgradeDialog({ open, onClose }: PlanUpgradeDialogProps) {
  const [selectingPlan, setSelectingPlan] = useState<PlanId | null>(null);
  const [upgradeError, setUpgradeError] = useState("");
  const [paymentPlan, setPaymentPlan] = useState<PaidPlanId | null>(null);
  const { user, setUser } = useAuthStore();
  const __ = useTranslate();

  async function selectPlan(id: PlanId) {
    if (id !== "free") {
      onClose();
      setPaymentPlan(id);
      return;
    }
    if (!window.confirm(__("เปลี่ยนเป็น Free ทันที? วันใช้งานแบบชำระเงินที่เหลือและคำขอที่รอตรวจจะถูกยกเลิก"))) return;
    setSelectingPlan(id);
    setUpgradeError("");
    try {
      const updated = await api.updatePlan(id);
      setUser(updated);
      onClose();
    } catch (caught) {
      setUpgradeError(caught instanceof Error ? caught.message : __("เปลี่ยนแผนไม่สำเร็จ"));
    } finally {
      setSelectingPlan(null);
    }
  }

  return <>
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
      <DialogTitle fontWeight={800}>{__("เปลี่ยนแผนการใช้งาน")}</DialogTitle>
      <DialogContent>
        {upgradeError && <Alert severity="error" sx={{ mb: 2 }}>{upgradeError}</Alert>}
        <PlanGrid
          mode="picker"
          currentPlanId={user?.plan}
          onSelect={(id) => void selectPlan(id)}
          selecting={selectingPlan}
        />
      </DialogContent>
    </Dialog>
    {paymentPlan && <PaymentSlipDialog
      open
      initialPlan={paymentPlan}
      onClose={() => setPaymentPlan(null)}
      onActivated={() => {
        void api.me().then(setUser);
        setPaymentPlan(null);
      }}
    />}
  </>;
}
